import { gql } from '@apollo/client';

export const FETCH_CIMITERI = gql`
  query FetchCimiteri($where: CimiteriWhereInput!) {
    cimiteris(where: $where) {
      edges {
        node {
          objectId
          nome
          alias
          citta
          frazione
          indirizzo
          cap
          provincia
          numero
        }
      }
    }
  }
`;
